 
export enum RequestMethod {
  GET,
  POST,
  PUT,
  PATCH,
  DELETE,
  // OPTIONS, TRACE, HEAD,
}
